export function header() {
  const path = location.pathname;

  const header = document.querySelector('.j-header');
  const headerBtn = document.querySelector('.j-header_btn');
  const headerLinks = document.querySelectorAll('.j-header_link');

  if (!header) return;

  let scrollPosition = 0;

  // 背景スクロール停止
  const lockBodyScroll = () => {
    scrollPosition = window.scrollY;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.width = '100%';
  };

  // 背景スクロール解除
  const unlockBodyScroll = () => {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.width = '';

    window.scrollTo(0, scrollPosition);
  };

  if (headerBtn) {
    headerBtn.addEventListener('click', () => {
      const isOpen = header.classList.toggle('active');

      if (isOpen) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    });
  }

  headerLinks.forEach((link) => {
    if (link.dataset.page === path) {
      link.classList.add('is-here');
    }
  });
}